 
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './Scrollable.scss';

const isNil = (x) => x == null;

export default class Scrollable extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    onScroll: PropTypes.func,
  };

  componentDidMount() {
    this._outerContainerRef.addEventListener('scroll', this._onScroll);
  }

  componentWillUnmount() {
    this._outerContainerRef.removeEventListener('scroll', this._onScroll);
  }

   
  get overflow() {
    const scroll = this.innerWidth > this.outerWidth;
    const left = scroll && this.scrollLeft > 0;
    const right = scroll && this.scrollLeft < this.innerWidth - this.outerWidth;
    if (left && right) {
      return 'both';
    }
    if (left) {
      return 'left';
    }
    if (right) {
      return 'right';
    }
    return 'none';
  }

  get innerWidth() {
    return isNil(this._innerContainerRef) ? 0 : this._innerContainerRef.clientWidth;
  }

  get outerWidth() {
    return isNil(this._outerContainerRef) ? 0 : this._outerContainerRef.clientWidth;
  }

  get scrollLeft() {
    return isNil(this._outerContainerRef) ? 0 : this._outerContainerRef.scrollLeft;
  }

  set scrollLeft(scrollLeft) {
    if (isNil(this._outerContainerRef)) return;
    this._outerContainerRef.scrollLeft = Math.max(
      0,
      Math.min(this.innerWidth - this.outerWidth, Number(scrollLeft)),
    );
  }

  scrollTo = offset => {
    if (Number.isNaN(Number(offset)) || !this._outerContainerRef || !this._innerContainerRef) {
      return;
    }
    const nextOffset = Math.max(0, Math.min(this.innerWidth - this.outerWidth, Number(offset)));
    const delta = nextOffset - this._outerContainerRef.scrollLeft;
    if (delta === 0) return;
    const onTransitionEnd = () => {
      this._innerContainerRef.removeEventListener('transitionend', onTransitionEnd);
      this._innerContainerRef.style.setProperty('transition', '');
      this._innerContainerRef.style.setProperty('transform', '');
      this._outerContainerRef.scrollLeft = nextOffset;
    };
    this._innerContainerRef.addEventListener('transitionend', onTransitionEnd);
    this._innerContainerRef.style.setProperty('transition', 'transform 0.5s ease-in-out');
    this._innerContainerRef.style.setProperty('transform', `translateX(${-delta}px)`);
  };

  _onScroll = event => {
    if (this.props.onScroll) {
      this.props.onScroll(event);
    }
  };

  _setOuterContainerRef = el => {
    this._outerContainerRef = el;
  };

  _setInnerContainerRef = el => {
    this._innerContainerRef = el;
  };

  _outerContainerRef = null;
  _innerContainerRef = null;

  render() {
    const { children: items } = this.props;
    return (
      <div className='sb-header__scrollable__container' ref={this._setOuterContainerRef}>
        <div className='sb-header__scrollable__content' ref={this._setInnerContainerRef}>
          {items}
        </div>
      </div>
    );
  }
}
